import { render, staticRenderFns } from "./SlidingMenu.vue?vue&type=template&id=16ab654c&scoped=true"
import script from "./SlidingMenu.vue?vue&type=script&lang=ts"
export * from "./SlidingMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlidingMenu.vue?vue&type=style&index=0&id=16ab654c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab654c",
  null
  
)

export default component.exports